module.exports = __webpack_public_path__ + "static/media/Icon-Component-Export.12cf1182.svg";